import { useEffect } from "react";
function useOutsideClickHandler(options) {
  const { ref, onOutsideClick } = options;
  useEffect(
    () => {
      function handleClickOutside(ev) {
        ref.current && !ref.current.contains(ev.target) && onOutsideClick(ev);
      }
      return document.addEventListener("mousedown", handleClickOutside, { passive: !0 }), () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps --
     *   should only fire if ref changes
     */
    [ref]
  );
}
export {
  useOutsideClickHandler
};
//# sourceMappingURL=useOutsideClickHandler.js.map
